export default __webpack_public_path__ + "media/AR-VR.90c7d916.svg";